import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13ef53ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "busStop-info-map" }
const _hoisted_2 = { class: "upper-btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "정류장 정보" }),
        _createVNode($setup["NaverMap"], {
          class: "map-content-area",
          latitude: $setup.busStop?.latitude,
          longitude: $setup.busStop?.longitude,
          showCurrentLocation: false,
          busStops: $setup.busStop ? [$setup.busStop] : [],
          selectedBusStop: $setup.busStop,
          zoomLevel: $setup.zoomLevel,
          minZoomLevel: $setup.MIN_ZOOM_LEVEL,
          maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
          onOnZoomChanged: $setup.updateZoomLevel
        }, null, 8 /* PROPS */, ["latitude", "longitude", "busStops", "selectedBusStop", "zoomLevel"]),
        _createElementVNode("section", _hoisted_2, [
          _createVNode($setup["MapZoomLevelSetter"], {
            class: "zoom-level",
            zoomLevel: $setup.zoomLevel,
            maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
            minZoomLevel: $setup.MIN_ZOOM_LEVEL,
            onZoomIn: $setup.updateZoomLevel,
            onZoomOut: $setup.updateZoomLevel
          }, null, 8 /* PROPS */, ["zoomLevel"]),
          _createElementVNode("button", {
            class: "street-view-btn-wrapper",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowStreetView(true)))
          }, [
            _createVNode($setup["InlineSvg"], {
              class: "img-street-view-btn",
              src: require('@/assets/icons/street-view.svg'),
              alt: "거리뷰 보기"
            }, null, 8 /* PROPS */, ["src"])
          ])
        ]),
        ($setup.busStop)
          ? (_openBlock(), _createBlock($setup["MapOfNearbyBusStopsBottomSheet"], {
              key: 0,
              ref: "bottomSheetModal",
              busStops: [$setup.busStop],
              selectedBusStop: $setup.busStop,
              updateKey: 0,
              lineInfos: $setup.lineInfos,
              maxHeightPx: $setup.maxHeightPx
            }, null, 8 /* PROPS */, ["busStops", "selectedBusStop", "lineInfos", "maxHeightPx"]))
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowStreetView,
        onBackHandler: () => $setup.toggleShowStreetView(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["BusStopStreetView"], {
            title: $setup.busStop?.name,
            latitude: $setup.busStop?.latitude,
            longitude: $setup.busStop?.longitude,
            onOnClickClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.toggleShowStreetView(false)))
          }, null, 8 /* PROPS */, ["title", "latitude", "longitude"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
    ]),
    _: 1 /* STABLE */
  }))
}